import React from 'react';

import { Skeleton } from '@iris/react-components';

/**
 * CardSkeleton - A reusable skeleton loader component for card layouts
 *
 * This component displays a skeleton loading state with an icon placeholder
 * and three lines of text placeholders in a horizontal layout.
 *
 * @returns {React.ReactElement} Rendered card skeleton
 */
function CardSkeleton() {
    return (
        <div className="iris:flex iris:items-start iris:gap-3 iris:w-full">
            <div className="iris:p-0 iris:h-[32px] iris:w-[32px] iris:flex-shrink-0">
                <Skeleton variant="rectangle" />
            </div>
            <div className="iris:p-0 iris:flex-1 iris:flex iris:flex-col iris:gap-2">
                <div className="iris:h-[16px] iris:w-4/5">
                    <Skeleton variant="text" />
                </div>
                <div className="iris:h-[16px] iris:w-full">
                    <Skeleton variant="text" />
                </div>
                <div className="iris:h-[16px] iris:w-1/2">
                    <Skeleton variant="text" />
                </div>
            </div>
        </div>
    );
}

export default CardSkeleton;
